import React,{useState,useEffect} from 'react'
import campaignService from '../../services/campaign.service'
import { useNavigate } from 'react-router-dom'
import {toast} from 'react-toastify'

const TemplateCard = ({campaign,getCampaignList})=>{
    const navigate = useNavigate()
    const handleEdit = (id)=>{
        navigate('template/'+id)
    }

    const handleDelete = (id) =>{
        campaignService.deleteTemplate(id)
        .then(res=>{
            toast.success("Deleted Template",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            getCampaignList()
        })
        .catch(err=>{
            toast.error("Error while Delete",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        })
    }

    const imagePath = campaign.preview === null ? "https://placehold.co/600x400?text=No+Preview":campaign.preview;

    return (
        <>
            <div className="card mb-3">
                <img src={imagePath} alt="" className='card-img-top' />
                <div className="card-body">
                    <h5 className="card-title">{campaign.name}</h5>
                    <p className='card-subtitle'>Id: {campaign.id} <small>{campaign.isActive === 1?"(Active)":"(Inactive)"}</small></p>
                </div>
                <div className="d-flex justify-content-between ps-3 pe-3 pb-3">
                    <button className="btn btn-sm btn-primary" onClick={()=>handleEdit(campaign.id)}><i className='bi bi-pencil'></i> Edit</button>
                    <button className="btn btn-sm btn-warning" onClick={()=>handleDelete(campaign.id)}><i className="bi bi-trash"></i> Delete</button>
                </div>
            </div>
        </>
    )
}
function CampaignTemplates() {
    const [campaignList,setCampaignList] = useState([])
    const statusString = ["Inactive", "Active"]
    const navigate = useNavigate()

    useEffect(()=>{
        getAllCampaign()
    },[])

    const getAllCampaign = ()=>{
        campaignService.getAllTemplates()
        .then(res=>{
            setCampaignList(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    }

   
    const handleEdit = (id)=>{
        navigate('template/'+id)
    }
    return (
    <>
        <div className='d-flex justify-content-end'>
           <button className="btn btn-success" onClick={()=>handleEdit("new")}><i className='bi bi-plus-circle-dotted'></i> Add New Campaign Template</button>
        </div>
       
                {campaignList && <>
                    <div className="row mt-3 p-3">
                            {campaignList.map((item,index)=>{
                                return(<div key={index} className='col-3'>
                                        <TemplateCard campaign={item} getCampaignList = {getAllCampaign}/>
                                </div>)
                            })}
                    </div>
                </>}
              
          
    </>
  )
}

export default CampaignTemplates